module.exports = __webpack_public_path__ + "img/cw_ys_yeWuFeiXaing.31630325.svg";